// Provider preset metadata mirrored from the design. Server sends an
// authoritative copy via /api/presets but we keep a local copy so the UI
// renders before that round-trip completes.

export const PROVIDER_PRESETS = [
  { key: 'stripe',      name: 'Stripe',       color: '#635bff', glyph: 'S' },
  { key: 'adyen',       name: 'Adyen',        color: '#0abf53', glyph: 'A' },
  { key: 'tamara',      name: 'Tamara',       color: '#ff4f88', glyph: 'T' },
  { key: 'mercadopago', name: 'Mercado Pago', color: '#00b0ff', glyph: 'M' },
  { key: 'nuvei',       name: 'Nuvei',        color: '#8a3ffc', glyph: 'N' },
  { key: 'dlocal',      name: 'dLocal',       color: '#e2356a', glyph: 'd' },
  { key: 'cybersource', name: 'Cybersource',  color: '#1e5fa4', glyph: 'C' },
  { key: 'kushki',      name: 'Kushki',       color: '#00c2a8', glyph: 'K' },
  { key: 'ebanx',       name: 'EBANX',        color: '#242935', glyph: 'E' },
  { key: 'pagsmile',    name: 'Pagsmile',     color: '#ff6a3d', glyph: 'P' },
  { key: 'klarna',      name: 'Klarna',       color: '#ffa8cd', glyph: 'K' },
  { key: 'afterpay',    name: 'Afterpay',     color: '#b2fce4', glyph: 'A' },
];

export function providerOf(key) {
  const p = PROVIDER_PRESETS.find(p => p.key === key);
  if (p) return { name: p.name, color: p.color, glyph: p.glyph };
  return { name: key || 'Custom', color: '#5a60ee', glyph: (key?.[0] || '?').toUpperCase() };
}
